/**
 * Slugs, not ids: `analytics_experiment.id` is generated per environment, so a numeric constant
 * matches locally and never on prod. Keep in step with the `ExperimentSlug` enum in backend-audio
 * (`web/components/ExperimentSlug.php`, same member names).
 */
export enum EXPERIMENT_SLUGS {
    PLAYER_2ND_AUDIO_REGWALL = 'player-2nd-audio-regwall',
    CONTEXTUAL_PRO_OFFER_CREATOR = 'contextual-pro-offer-creator',
}
